export let ROUTES: RouteInfo[] = [
  {
    path: "/alerts/forest-fire",
    title: "Forest Fire Alerts",
    icon: "nc-sun-fog-29",
    class: "",
    type: "link",
  },
  {
    path: "/nodes",
    title: "Nodes",
    icon: "nc-atom",
    class: "",
    type: "sub",
    children: [],
  },
];
